import { useTranslation } from "react-i18next";
import Loader, { LOADER_SIZES } from "./Loader";

export default function PageHeadline({ title, classList, loader = false }) {
  const { t } = useTranslation("general");

  return (
    <>
      <h1 className={`t-headline-1 u-margin_0 ${classList ? classList : ""}`}>
        {t(title)}
        {loader && <Loader size={LOADER_SIZES.SMALL} withoutText />}
      </h1>
    </>
  );
}
